export default {
    methods: {
    
     /**
     * Poccettino per sostituire e ridisegnare i tasti del drawer
     */
    GoogleMapDrawerButtons_redrawButtonsTools() {
        setTimeout(() => {
            this.restyleButtonTool()
      
            $(".gmnoprint").fadeIn();
        }, 500);
    },

    /**
     * Resetto i bottoni del drawer
     */
    resetRedraw() {
        var cerchio = $("#btnCerchio");
        cerchio.attr("id", "btnCerchio");
        cerchio.find('div').css( "background-image", "url('https://img.icons8.com/ios/50/000000/0-degrees.png')" )
           
        // ID the Marker button
        var cursor = $("#btnSmetti");
        cursor.attr("id", "btnSmetti");
        cursor.find('div').css( "background-image", "url('https://img.icons8.com/ios/50/000000/generic-mouse.png')" )

        // ID the line button
        var poligono = $('#btnForma');
        poligono.attr("id", "btnForma");
        poligono.find('div').css( "background-image", "url('https://img.icons8.com/ios/50/000000/polygon.png')" )
    },

    /**
     * Gestisco gli eventi click per cambiare le icone
     */
    restyleButtonTool() {
        let self = this;
         $(".gmnoprint").each(function() {
            var cerchio = $(this).find("[title='Traccia un cerchio']");
            cerchio.attr("id", "btnCerchio");
            cerchio.find('div').css( "background-image", "url('https://img.icons8.com/ios/50/000000/0-degrees.png')" )
            
            cerchio.on('click', function(event) {
                self.resetRedraw();
                $(event.currentTarget).find('div').css( "background-image", "url('https://img.icons8.com/ios/50/c41f1f/0-degrees.png')" );
            })
           
            // ID the Marker button
            var cursor = $(this).find("[title='Smetti di tracciare']");
            cursor.attr("id", "btnSmetti");
            cursor.find('div').css( "background-image", "url('https://img.icons8.com/ios/50/000000/generic-mouse.png')" )

            cursor.on('click', function(event) {
                self.resetRedraw();
                $(event.currentTarget).find('div').css( "background-image", "url('https://img.icons8.com/ios/50/c41f1f/generic-mouse.png')" );
            })

            // ID the line button
            var poligono = $(this).find("[title='Traccia una forma']");
            poligono.attr("id", "btnForma");
            poligono.find('div').css( "background-image", "url('https://img.icons8.com/ios/50/000000/polygon.png')" )

            poligono.on('click', function(event) {
                self.resetRedraw();
                $(event.currentTarget).find('div').css( "background-image", "url('https://img.icons8.com/ios/50/c41f1f/polygon.png')" );
            })
        });
    },
    }
}